<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Ψηφιακός Ατομικός Φάκελος</h4>
          <p class="card-title-desc">Διαχείριση και επεξεργασία</p>

          <!-- <b-tabs
            justified
            nav-class="nav-tabs-custom"
            content-class="p-3 text-muted"
          > -->
          <b-tabs content-class="p-3 text-muted">
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-user-cog"></i>
                </span>
                <span class="d-none d-sm-inline-block">
                  Προσωπικά Στοιχεία Χρήστη</span>
              </template>
              <UserTab></UserTab>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-table"></i>
                </span>
                <span class="d-none d-sm-inline-block">Τμήμα και Ρόλος Χρήστη</span>
              </template>
              <UserTab2></UserTab2>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-user-check"></i>
                </span>
                <span class="d-none d-sm-inline-block"> Ρολόι Παρουσίας</span>
              </template>
              <UserTab3></UserTab3>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-calendar-day"></i>
                </span>
                <span class="d-none d-sm-inline-block"> Ωράριο Εργασίας</span>
              </template>
              <UserTab4></UserTab4>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-grin-stars "></i>
                </span>
                <span class="d-none d-sm-inline-block"> Άδειες</span>
              </template>
              <div class="row">
                <h3 class="card-title" style="text-decoration:underline;">
                  Άδειες
                </h3>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Α/Α</th>
                        <th>Έναρξη</th>
                        <th>Λήξη</th>
                        <th>Aδεια</th>
                        <th>Σχόλια</th>
                        <th>Βρίσκεται σε άδεια</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody v-if="!hrmsActive">
                      <tr v-for="(holiday, index) in personLeave.results" :key="index">
                        <th scope="row">
                          {{
                            personLeave.current_page * perPage -
                            perPage +
                            index +
                            1
                          }}
                        </th>

                        <td>
                          {{
                            holiday.holidays_start_date
                              .split("-")
                              .reverse()
                              .join("-")
                          }}
                        </td>
                        <td>
                          {{ holiday.holidays_end_date
                            .split("-")
                            .reverse()
                            .join("-")
                          }}
                        </td>
                        <td>{{ holiday.holiday_type_name }}</td>
                        <td v-if="holiday.comments">
                          {{ holiday.comments }}
                        </td>
                        <td v-else>
                          -
                        </td>
                        <td v-if="holiday.on_holidays" class="fas fa-check" style="color:green"></td>
                        <td v-else class="fas fa-times" style="color:red"></td>
                        <td v-if="new Date(holiday.holidays_end_date) > new Date()">
                          <i class="mdi mdi-pencil" @click.prevent="$bvModal.show(`Rel${holiday.id}`)"></i>

                          <b-modal :id="`Rel${holiday.id}`" title="Επεξεργασία άδειας" centered hide-footer>
                            <EditModal cardTitle="Επεξεργασία άδειας" description="Επεξεργασία άδειας χρήστη"
                              :holidayObject="holiday" @holidayUpdated="holidayUpdated" />
                          </b-modal>

                          <i class="mdi mdi-trash-can" @click.prevent="confirm(holiday.id)"
                            v-if="new Date(holiday.holidays_start_date) > new Date()"></i>
                        </td>
                      </tr>
                      <button class="btn btn-primary" v-b-modal.addHolidayType>
                        Προσθήκη Άδειας
                      </button>
                      <b-modal id="addHolidayType" title="Προσθήκη Άδειας στον Χρήστη" centered hide-footer>
                        <ModalForm cardTitle="Προσθήκη Άδειας" description="Προσθέστε Αδεια στον Χρήστη"
                          @holidayCreated="holidayCreated" />
                      </b-modal>
                    </tbody>
                    <!-- HRMS LEAVE -->
                    <tbody v-else>
                      <tr v-for="(holiday, index) in personHrmsLeave" :key="index">
                        <th scope="row">
                          {{ index + 1 }}
                        </th>

                        <td v-if="holiday != null">
                          {{ holiday.from_leave_date.split("T")[0] }}
                        </td>
                        <td v-if="holiday != null">
                          {{ holiday.to_leave_date.split("T")[0] }}
                        </td>
                        <td v-if="holiday != null">
                          {{ holiday.lty_descr }}
                        </td>
                        <td v-if="holiday != null" class="fas fa-check" style="color:green"></td>
                      </tr>
                    </tbody>
                    <!-- END OF HRMS LEAVE -->
                  </table>
                </div>
                <!-- <b-pagination
                  v-model="currentPage"
                  :total-rows="userHolidays.count"
                  :per-page="perPage"
                ></b-pagination> -->
                <!-- Create user holidays api and buttons | fetch from hrms -->
              </div>
            </b-tab>

            <!-- <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-table"></i>
                </span>
                <span class="d-none d-sm-inline-block">Ψηφιακός Φάκελος</span>
              </template>
              <PsifiakosFakelos></PsifiakosFakelos>
            </b-tab> -->

            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-table"></i>
                </span>
                <span class="d-none d-sm-inline-block">Εργασιακά / Μισθολογικά</span>
              </template>
              <Ergasiaka></Ergasiaka>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-table"></i>
                </span>
                <span class="d-none d-sm-inline-block">Προυπηρεσία / Στοιχεία Προυπηρεσίας</span>
              </template>
              <Proipiresia></Proipiresia>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-table"></i>
                </span>
                <span class="d-none d-sm-inline-block">Εκπαίδευση</span>
              </template>
              <Ekpaideusi></Ekpaideusi>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-table"></i>
                </span>
                <span class="d-none d-sm-inline-block">Ξένες Γλώσσες</span>
              </template>
              <Glwsses></Glwsses>
            </b-tab>

            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-table"></i>
                </span>
                <span class="d-none d-sm-inline-block">Έγγραφα</span>
              </template>
              <Eggrafa></Eggrafa>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../../api/session";
import { mapState, mapGetters } from "vuex";
import ModalForm from "./form-modal.vue";
import EditModal from "./edit-modal.vue";
import { weekDays } from "../utils";

import UserTab from "./UserTab.vue";
import UserTab2 from "./UserTab2.vue";
import UserTab3 from "./UserTab3.vue";
import UserTab4 from "./UserTab4.vue";
// import PsifiakosFakelos from "./UserTabPsifiakosFakelos.vue";
import Ergasiaka from "./UserTabErgasiaka.vue";
import Proipiresia from "./UserTabProipiresia.vue";
import Ekpaideusi from "./UserTabEkpaideusi.vue";
import Glwsses from "./UserTabGlwsses.vue";
import Eggrafa from "./UserTabFiles.vue";
import Swal from "sweetalert2";
import { eventCreate } from "../../../../eventspy.js";

export default {
  page: {
    title: "Προσωπικό",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,

    ModalForm,
    EditModal,
    UserTab,
    UserTab2,
    UserTab3,
    UserTab4,
    // PsifiakosFakelos,
    Ergasiaka,
    Proipiresia,
    Ekpaideusi,
    Glwsses,
    Eggrafa,
  },
  data() {
    return {
      title: "Προσωπικο",
      items: [
        {
          text: "Προσωπικό",
          to: { name: "staff-users" },
        },
        {
          text: "Πληροφορίες Χρήστη",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      userDetail: [],
      noUserFoundError: "",
      personLeave: [],
    };
  },

  mounted() {
    this.fetchCurrentUser();
    this.fetchLeaveFromHrms();
    this.fetchPersonHolidays();
  },
  watch: {
    currentPage(value) {
      this.personLeave = {
        ...this.personLeave,
        page: value,
      };
      this.fetchPersonHolidays();
    },
  },

  computed: {
    ...mapState("utils", [
      "departments",
      "devices",
      "employmentRelationShips",
      "personDetails",
      "departmentOptions",
      "departments",
      "roleChoices",
      "roles",
    ]),
    ...mapGetters("auth", ["userLoggedIn", "is_staff"]),
    ...mapGetters("utils", ["hrmsActive"]),

    weekdayOptions() {
      return weekDays.map((e) => e.weekday);
    },
  },
  methods: {
    async fetchLeaveFromHrms() {
      await session
        .get(`api/hrms/person/${this.$route.params.id}/leave/`)
        .then((resp) => {
          this.personHrmsLeave = resp.data;
        });
    },

    async fetchPersonHolidays() {
      const filterUrlParams = new URLSearchParams();
      if (this.personLeave.page) {
        filterUrlParams.append("page", this.personLeave.page);
      }
      await session
        .get(
          `api/person/${this.$route.params.id
          }/holidays/?${filterUrlParams.toString()}`
        )
        .then((resp) => {
          this.personLeave = resp.data;
          // console.log("Holidays:", resp.data);
        });
    },

    async fetchCurrentUser() {
      await session
        .get(`api/user/${this.$route.params.id}/`)
        .then((resp) => {
          this.userDetail = resp.data;
        })
        .catch((e) => {
          console.log(e);
          if (e.response.data.details) {
            this.noUserFoundError = e.response.data.details;
          }
        });
    },
    deleteHoliday(holidayID) {
      setTimeout(() => {
        session.delete(`api/person/holiday/${holidayID}/actions/`).then(() => {
          this.fetchPersonHolidays();
        });
      }, 1000);
    },
    confirm(holidayID) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          eventCreate(`Διέγραψε την άδεια ${holidayID}`, 3);
          this.deleteHoliday(holidayID);
          Swal.fire({
            title: "Διαγράφηκε!",
            text: "Η άδεια έχει διαγραφεί.Η άδεια θα διαγραφεί από όλα τα ρολόγια και θα ειδοποιηθείτε μόλις ολοκληρωθεί η διαδικασία.",
            icon: "success",
            timer: 3000,
          });
        }
      });
    },
    holidayCreated() {
      this.$bvModal.hide("addHolidayType");
      this.fetchPersonHolidays();
    },
    holidayUpdated(holidayID) {
      this.$bvModal.hide(`Rel${holidayID}`);
      this.fetchPersonHolidays();
    },
  },
};
</script>
<style scoped>
.mdi-pencil {
  padding: 10px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
  cursor: pointer;
  font-size: 20px;
}

.mdi-trash-can {
  color: red;
  padding: 10px;
  transition: all 0.6s;
  cursor: pointer;
  font-size: 20px;
}
</style>